var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hubble-plot-alarm-tooltip",style:({ left: _vm.positionX, top: _vm.positionY })},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"heading"},[_vm._v(" "+_vm._s(_vm.time)+" ")]),_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }